import classes from "./Kiosk_viennaPlzen_redesign.module.css";
import {React, useEffect, useState} from "react";
import bck from "../../../store/Harrachov/16x84246610.jpg";
import bck2 from "../../../store/Vienna/defScr/fe64807a-76d3-44d9-9a9a-8120d3fe7314.jpg";
import bck3 from "../../../store/Vienna/defScr/2ff1fb60-d141-4d82-b0a9-ed61115c7b56.jpg";
import bck4 from "../../../store/Vienna/defScr/b9400740-ea13-4683-829b-52e3920a0b6e.jpg";
import bck5 from "../../../store/Vienna/defScr/1475152f-9ee7-4e15-91cb-4961525d1e15.jpg";
import axios from "axios";
import {path} from "../../../routes";
import Tl1 from "../../../store/Harrachov/tl01n.jpg";
import Tl2 from "../../../store/Harrachov/tl02n.jpg";
import Tl3 from "../../../store/Harrachov/tl03n.jpg";
import Akce from "../../../store/Harrachov/card.jpg";
import {CircularProgress} from "@mui/material";
import logo from "../../../store/Harrachov/maxresdefault.jpg";
import cloud from "../../../store/cloud-icon-17.png";
import backMenu from "../../../store/Vienna_new/Vienna House Easy by Wyndham Pilsen - Exterior - bez transparentu.jpg"
import video from "../../../store/Vienna_new/video.mp4"
import cnn from "../../../store/Vienna_new/Cnn_logo_red_background.png"
import room from "../../../store/Vienna_new/Vienna House Easy by Wyndham Pilsen - Executive Double Room - 1550170.jpg"
import back from "../../../store/Vienna_new/back-flat-color-outline-icon-free-png.webp"
import suproom from "../../../store/Vienna_new/Vienna House Easy by Wyndham Pilsen - Superior Double Room - 1550188.jpg"
import Sleep from "./VIENNA_PLZEN/Sleep";
import Eat from "./VIENNA_PLZEN/Eat";
import Meet from "./VIENNA_PLZEN/Meet";
import {Expand, Explore} from "@mui/icons-material";
import ExploreVienna from "./VIENNA_PLZEN/Explore";
import MeetingGraph from "./KioskPages/MeetingGraph";
import MeetingStairs from "./KioskPages/MeetingStairs";
import Bar from "./KioskPages/Bar";
import SlideShowKiosk_redesign from "./KioskPages/SlideShowKiosk_redesign";
import SlideShowKiosk_redesign_Harrachov from "./KioskPages/SlideShowKiosk_redesign_Harrachov";

const Kiosk_Harrachov = (props) => {
    const [backgrounds, setBackgrounds] = useState([bck]);
    const [currentIndexA, setCurrentIndexA] = useState(0);
    const [currentIndexnews, setCurrentIndexnews] = useState(0);
    const [currentIndexMeets, setCurrentIndexMeets] = useState(0);
    const [actTime, setactTime] = useState("undefined");
    const [actDate, setactDate] = useState("undefined");
    const [roomName, setroomName] = useState(props.roomName);
    const [logoOrg, setLogoOrg] = useState(props.logoOrg);
    const [news, setNews] = useState([]);
    const [meetings, setMeetings] = useState([]);
    const [news2, setNews2] = useState();

    const [newsData, setNewsData] = useState([]);
    const [weatherData, setWeatherData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [state, setState] = useState(0);
    const [language, setLanguage] = useState(0);
    const [footerShow, setfooterShow] = useState(2);
    const [bodyRes, setbodyRes] = useState(2);
    const [step, setStep] = useState(0);
    const [group, setGroup] = useState(1);
    const [header, setHeader] = useState(false);
    const [newstep, setNewStep] = useState(0);
    const [stepMainMenu, setStepMainMenu] = useState(0);

    const fetch_meetings = async () => {
        setCurrentIndexMeets(0)
        let state = (await getDevice())
        const dt = new Date
        const date = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}`
        const actTime = `${dt.getFullYear()}-${String(dt.getMonth() + 1).padStart(2, "0")}-${String(dt.getDate()).padStart(2, "0")}T${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}:${String(dt.getSeconds()).padStart(2, "0")}`;
        try {
            const response = await axios.get(`${path}/getRecordsNowV2?orgID=306F8ACA-52B0-443E-9404-12BD242FF7C5&day=${actTime}`);
            setMeetings(response.data);
            decision_handler(response.data, state)
        } catch (error) {
            console.log(error)
            setStep(0)
        }

    }

    const getDevice = async () => {
        try {
            let response = await axios.get(`${path}/getRoomDetail/${props.id == 1 ? 80 : null}`);
            setState(response.data[0].KioskState)
            return response.data[0].KioskState
        } catch (err) {
            console.log(error)
            return null
        }
    }

    const decision_handler = (x, y) => {
        //debugger
                console.log(":0")
                setHeader(true)
                if (x.length != 0) {
                    if (props.id == 1) {
                        setStepMainMenu(2)
                        setNewStep(0)
                        //setStep(11)
                    }
                    if (props.id == 2) {
                        //setStep(7)
                        setStepMainMenu(2)
                        setNewStep(0)
                    }
                }
                if (x.length == 0) {
                    if (props.id == 1) {
                        setGroup(24)
                        setHeader(false)
                        setNewStep(12)
                        //setStep(10)
                    }
                    if (props.id == 2) {

                    }
                }
    }

    const fetchNews = async (gr) => {
        try {
            let tmp = []
            const response = await axios.get(`${path}/getNews`);
            for (let i = 0; i < response.data.length; i++) {
                tmp.push(response.data[i].description)
            }
            setNews(tmp)
            console.log(tmp)
        } catch (error) {
            console.error('Error deleting row:', error);
        }
    }
    const resetscreen = () => {
        console.log("reset screen")
        setNewStep(0)
    };

    /*
    STEPS
    0 - MENU + FOOTER PREZ
    1 - MEETING TXT + FOOTER MENU
    2 - MEETING MAP WITHOUT FOOTER
    3 - MEETING EVENTS + FOOTER MENU
    4 - RESTAURANT + FOOTER MENU
    5 - ROOMS + FOOTER MENU
    6 - BAR + FOOTER MENU
    7 - MEETING SLIDESHOW + FOOTER MENU
    8 - MEETING LIST WITHOUT FOOTER
    9 - MEETING DETAIL WITHOUT FOOTER
    * */
    const changeStep_handler = (step) => {
        setStep(step);
    }
    const changeGroup_handler = (id) => {
        setGroup(id);
    }
    const reload_handler = () => {
        console.log("reload_handler")
    }

    useEffect(() => {

        const apiKeyNews = '103cea4011e44292b5c47cd9c7808d1c';
        const apiUrlNews = `https://newsapi.org/v2/top-headlines?country=us&apiKey=${apiKeyNews}`;
        const apiKeyWea = '53aaf5c2175c0194becf66b6a9f26436';
        const city = 'Praha';
        const apiUrlWea = `https://api.openweathermap.org/data/2.5/weather?q=${city}&appid=${apiKeyWea}&units=metric`;

        const fetchWeather = async () => {
            try {
                const response = await fetch(apiUrlWea);
                if (!response.ok) {
                    throw new Error('Chyba při načítání dat o počasí');
                }
                const data = await response.json();
                setWeatherData(Math.round(data.main.temp));
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        const updateMinute = () => {
            let dt = new Date
            //console.log(dt)
            setactTime(`${String(dt.getHours()).padStart(2, "0")}:${String(dt.getMinutes()).padStart(2, "0")}`)
            setactDate(`${String(dt.getDate()).padStart(2, "0")}. ${String(dt.getMonth() + 1).padStart(2, "0")}. ${dt.getFullYear()}`)
        };
        updateMinute()
        const intervalId = setInterval(updateMinute, 1000);

        fetchWeather();
        return () => clearInterval(intervalId);
    }, []);
    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentIndexA((prevIndex) => (prevIndex + 1) % backgrounds.length);
        }, 10000);
        return () => {
            clearInterval(intervalId);
        };
    }, [backgrounds]);

    useEffect(() => {
        const intervalIdNews = setInterval(() => {
            setCurrentIndexnews((prevIndex) => (prevIndex + 1) % news.length);
        }, 15000);
        return () => {
            clearInterval(intervalIdNews);
        };
    }, [news]);

    useEffect(() => {
        const intervalIdMeets = setInterval(() => {
            setCurrentIndexMeets((prevIndex) => (prevIndex + 1) % meetings.length);
        }, 15000);
        return () => {
            clearInterval(intervalIdMeets);
        };
    }, [meetings]);

    useEffect(() => {
        const intervalfetchmeeting = setInterval(() => {
            fetch_meetings()
        }, 20 * 1000);
        return () => {
            clearInterval(intervalfetchmeeting);
        };
    }, [news]);

    useEffect(() => {

        const hourDelay = 60 * 60 * 1000; // 1 hour in milliseconds
        const refreshPage = setTimeout(() => {
            console.log("reload_handler")
        }, hourDelay);


        return () => {
            clearTimeout(refreshPage);
        };
    }, []);

    useEffect(() => {
        fetchNews()
        fetch_meetings()
    }, []);


    const language_handler = () => {
        language == 0 ? setLanguage(1) : setLanguage(0)
    }
    const loader = <CircularProgress color="error" size={100}/>
    /*
    STEPS
    0 - MENU + FOOTER PREZ
    1 - MEETING TXT + FOOTER MENU
    2 - MEETING MAP WITHOUT FOOTER
    3 - MEETING EVENTS + FOOTER MENU
    4 - RESTAURANT + FOOTER MENU
    5 - ROOMS + FOOTER MENU
    6 - BAR + FOOTER MENU
    7 - MEETING SLIDESHOW + FOOTER MENU
    8 - MEETING LIST + FOOTER MENU
    9 - MEETING DETAIL WITHOUT FOOTER
    * */

    const mainMenu = <>
        <div className={classes.bodyContainer}>
            <div className={classes.bodyContainerHarr}>
               <div className={classes.divHarr}>
                   <img src={Tl1} onClick={()=>{setStepMainMenu(0)}}/>
               </div>
                <div className={classes.divHarr}>
                    <img src={Tl2} onClick={()=>{setStepMainMenu(1)}}/>
                </div>
                <div className={classes.divHarr}>
                    <img src={Tl3} onClick={()=>{setStepMainMenu(2)}}/>
                </div>

            </div>
            <div className={classes.bodyContainerHarrRest}>
                <div className={classes.divHarrSto}>
                    {stepMainMenu == 0 && <p></p>}
                    {stepMainMenu == 1 && <img src={Akce}/>}
                    {(stepMainMenu == 2 && meetings.length>0) && <img src={`${path}/admin/${meetings[currentIndexMeets].path}`}/>}
                </div>
            </div>
        </div>
        <div className={classes.footerContainerHarr}>
            <img src={backgrounds[currentIndexA]}/>
        </div>
    </>

    const setNewStep_handler = (x) => {
        setNewStep(x)
    }

    return <div className={classes.mainHarr}>
        {header && <div className={classes.headerHarr}>
            <div className={classes.hUp}>
                <div className={classes.box}>
                    <img src={logo} alt={"logo"} onClick={() => {
                        reload_handler()
                    }}/>
                </div>
                <div className={classes.line}></div>
                <div className={classes.boxC}>
                    <img src={cloud}/>
                    <div className={classes.timeC}>{weatherData && `${weatherData}\u00b0`}</div>
                </div>
                <div className={classes.line}></div>
                <div className={classes.boxB}>
                    <div className={classes.timeA}>{actTime}</div>
                    <div className={classes.lineT}>a</div>
                    <div className={classes.timeB}>{actDate}</div>
                </div>
            </div>
        </div>}
        {newstep == 0 && mainMenu}

        {newstep == 12 && <SlideShowKiosk_redesign_Harrachov changeStep={changeStep_handler} groupID={group}/>}

    </div>
}
export default Kiosk_Harrachov